import { HttpBasicRequest } from 'app/shared/models/http-basic-request.model';
import { BasicHttpClientService } from 'app/shared/services/basic-http-client.service';
import { Observable, Subject } from 'rxjs';

import { ContactList, ContactVM } from '../models/back-office-admin-common/contact.models';
import { ContactMapper } from './contact-mapper';

export class ContactCRUD {


  public static ContactCreateOrEditOrDelete(loaderID: string, _httpClient: BasicHttpClientService, baseUrl: string, contactList: ContactVM[], cacheContactList: ContactVM[], type: 'customer' | 'agency' | 'pos', id?: number, locationID?: number,): Observable<any[]> {
    const contactsCreateRequest: HttpBasicRequest[] = ContactMapper.contactsCreateRequest(contactList, baseUrl)
    const contactsEditRequest: HttpBasicRequest[] = ContactMapper.contactsEditRequest(contactList, cacheContactList, baseUrl)
    let contactsDeleteRequest: HttpBasicRequest[];
    switch (type) {
      case 'customer':
        contactsDeleteRequest = ContactMapper.contactsCustomerDeleteRequest(contactList, cacheContactList, baseUrl, id, locationID)
        break;
      case 'agency':
        contactsDeleteRequest = ContactMapper.contactsAgencyDeleteRequest(contactList, cacheContactList, baseUrl, id)
        break;
      case 'pos':
        contactsDeleteRequest = ContactMapper.contactsDeleteRequest(contactList, cacheContactList, baseUrl)
        break;
    }

    const result = new Subject<any[]>();
    if (contactsCreateRequest.length === 0 && contactsEditRequest.length === 0 && contactsDeleteRequest.length === 0) {
      setTimeout(() => result.next([]));
    } else {
      _httpClient.forkJoin<any>([...contactsCreateRequest, ...contactsEditRequest, ...contactsDeleteRequest], loaderID).subscribe((res) => {
        const addContact: HttpBasicRequest[] = []
        const contacts: ContactVM[] = res.slice(0, contactsCreateRequest.length);
        if (contacts.length === 0) {
          result.next((res || []))
        } else {
          contacts.forEach(contact => {
            switch (type) {
              case 'customer':
                addContact.push({ url: baseUrl + `/customers/${id}/contact-loc/${locationID}`, method: 'post', body: { contactId: contact.id } })
                break;
              case 'agency':
                addContact.push({ url: baseUrl + `/agencies/${id}/contact/${contact.id}`, method: 'post', })
                break;
              case 'pos':
                addContact.push({ url: baseUrl + `/point-of-sales/${id}/contact-pos/${contact.id}`, method: 'post', })
                break;
            }
          });
          _httpClient.forkJoin([...addContact], loaderID).subscribe(resAddContact => {
            result.next([...res, ...resAddContact])
          }, error => {
            console.error(error);
          })
        }
      }, error => {
        console.error(error);
      })
    }
    return result
  }

  public static ContactCreateOrEditOrDeleteOld(loaderID: string, _httpClient: BasicHttpClientService, baseUrl: string, contactList: ContactList, cacheContactList: ContactList, type: 'customer' | 'agency' | 'pos', id?: number, locationID?: number,): Observable<any[]> {
    const contactsCreateRequest: HttpBasicRequest[] = ContactMapper.contactsCreateRequestOld(contactList, baseUrl)
    const contactsEditRequest: HttpBasicRequest[] = ContactMapper.contactsEditRequestOld(contactList, cacheContactList, baseUrl)
    let contactsDeleteRequest: HttpBasicRequest[];
    switch (type) {
      case 'customer':
        contactsDeleteRequest = ContactMapper.contactsCustomerDeleteRequestOld(contactList, cacheContactList, baseUrl, id, locationID)
        break;
      case 'agency':
        contactsDeleteRequest = ContactMapper.contactsAgencyDeleteRequestOld(contactList, cacheContactList, baseUrl, id)
        break;
      case 'pos':
        contactsDeleteRequest = ContactMapper.contactsDeleteRequestOld(contactList, cacheContactList, baseUrl)
        break;
    }

    const result = new Subject<any[]>();
    if (contactsCreateRequest.length === 0 && contactsEditRequest.length === 0 && contactsDeleteRequest.length === 0) {
      setTimeout(() => result.next([]));
    } else {
      _httpClient.forkJoin<any>([...contactsCreateRequest, ...contactsEditRequest, ...contactsDeleteRequest], loaderID).subscribe((res) => {
        const addContact: HttpBasicRequest[] = []
        const contacts: ContactVM[] = res.slice(0, contactsCreateRequest.length);
        if (contacts.length === 0) {
          result.next((res || []))
        } else {
          contacts.forEach(contact => {
            switch (type) {
              case 'customer':
                addContact.push({ url: baseUrl + `/customers/${id}/contact-loc/${locationID}`, method: 'post', body: { contactId: contact.id } })
                break;
              case 'agency':
                addContact.push({ url: baseUrl + `/agencies/${id}/contact/${contact.id}`, method: 'post', })
                break;
              case 'pos':
                addContact.push({ url: baseUrl + `/point-of-sales/${id}/contact-pos/${contact.id}`, method: 'post', })
                break;
            }
          });
          _httpClient.forkJoin([...addContact], loaderID).subscribe(resAddContact => {
            result.next([...res, ...resAddContact])
          }, error => {
            console.error(error);
          })
        }
      }, error => {
        console.error(error);
      })
    }
    return result
  }

  public static PosContactCreateRequests(loaderId: string, _httpClient: BasicHttpClientService, baseUrl: string, data: { contactList: ContactVM[], posId?: number }[]): Observable<any[]> {
    let contactsCreateRequest: HttpBasicRequest[] = [];
    data?.forEach(el => contactsCreateRequest = contactsCreateRequest.concat(ContactMapper.contactsCreateRequest(el.contactList, baseUrl, el.posId)));
    const result = new Subject<any[]>();
    _httpClient.forkJoin<any>(contactsCreateRequest, loaderId).subscribe((res) => {
      const addContact: HttpBasicRequest[] = [];
      res.forEach((contact, i) => addContact.push({ url: baseUrl + `/point-of-sales/${contactsCreateRequest[i].parentId}/contact-pos/${contact.id}`, method: 'post', }));
      _httpClient.forkJoin(addContact, loaderId).subscribe(resAddContact =>
        result.next(resAddContact),
        error => console.error(error)
      );
    }, error => {
      console.error(error);
    })
    return result
  }

  public static PosContactCreateRequestsOld(loaderId: string, _httpClient: BasicHttpClientService, baseUrl: string, data: { contactList: ContactList, posId?: number }[]): Observable<any[]> {
    let contactsCreateRequest: HttpBasicRequest[] = [];
    data?.forEach(el => contactsCreateRequest = contactsCreateRequest.concat(ContactMapper.contactsCreateRequestOld(el.contactList, baseUrl, el.posId)));
    const result = new Subject<any[]>();
    _httpClient.forkJoin<any>(contactsCreateRequest, loaderId).subscribe((res) => {
      const addContact: HttpBasicRequest[] = [];
      res.forEach((contact, i) => addContact.push({ url: baseUrl + `/point-of-sales/${contactsCreateRequest[i].parentId}/contact-pos/${contact.id}`, method: 'post', }));
      _httpClient.forkJoin(addContact, loaderId).subscribe(resAddContact =>
        result.next(resAddContact),
        error => console.error(error)
      );
    }, error => {
      console.error(error);
    })
    return result
  }
}
